import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

var pos = 0;

export default class Storyboard_3 extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.STORYBOARD_3);
	}

	init() {
		pos = 0;
	}

	preload() {
		this.load.image('visiting-grandpa-bg', 'assets/Storyboards/visitinggrandpa_background.png');
	}

	create(data) {
		const map = this.add.image(0, 0, 'visiting-grandpa-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 4401, 10763); //Left, Top, X Limit, Y Limit
		cam.setZoom(0.5); //0.8
		cam.centerOn(3150, 1060); //1100, 800

		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		data.next
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos++;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 1:
							cam.pan(0, 800, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 2:
							cam.pan(0, 2800, 1000);
							break;
						case 3:
							cam.pan(0, 4900, 1000);
							break;
						case 4:
							cam.pan(0, 5550, 1000);
							break;
						case 5:
							cam.pan(1100, 7530, 1000);
							cam.zoomTo(0.5, 1000);
							break;
						case 6:
							cam.pan(3200, 7400, 1000);
							cam.zoomTo(0.45, 1000);
							break;
						case 7:
							cam.pan(0, 10763, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 8:
							pos = 0;
							data.next.setVisible(false);
							data.previous.setVisible(false);
							data.pause.setVisible(false);
							this.scene.resume(CST.SCENES.MAIN_QUESTIONS, {
								User_ID: this.User_ID,
								story: 3,
							});
							this.scene.stop();
							break;
					}
				},
				this,
			);

		data.previous
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos--;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 0:
							cam.pan(3150, 1060, 1000);
							cam.zoomTo(0.5, 1000);
							break;
						case 1:
							cam.pan(0, 800, 1000);
							break;
						case 2:
							cam.pan(0, 2800, 1000);
							break;
						case 3:
							cam.pan(0, 4900, 1000);
							break;
						case 4:
							cam.pan(0, 5550, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 5:
							cam.pan(1100, 7530, 1000);
							cam.zoomTo(0.5, 1000);
							break;
						case 6:
							cam.pan(3200, 7400, 1000);
							cam.zoomTo(0.45, 1000);
							break;
						case 7:
							cam.pan(0, 10763, 1000);
							cam.zoomTo(0.35, 1000);
							break;
					}
				},
				this,
			);
	}
}
